
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import styles from '../../styles/home/earnBeyondSection.module.scss';
export default function EarnBeyondSection() {
    const signUpUrl = process.env.NEXT_PUBLIC_APP_URL + '/sign-up';
    return (<section className={styles.earnBeyondSection}>
      <div className={'container'}>
        <div className={styles.cardsRow}>
          <div className={styles.card}>
            <div className={styles.iconWrapper}>
              <img src="/images/earn-beyond/icon-form.svg" alt="Points icon" className={styles.icon}/>
            </div>
            <h3 className={styles.cardTitle}>
              HFDX points are earned through<br />investment participation
            </h3>
            <a href={signUpUrl} className={styles.viewButton}>
              <span className={styles.buttonText}>View More</span>
              <div className={styles.arrowIconWrapper}>
                <div className={styles.arrowIcon}>
                  <img src="/images/earn-beyond/arrow-small.svg" alt="" role="presentation"/>
                </div>
              </div>
            </a>
          </div>

          <div className={styles.card}>
            <div className={styles.iconWrapper}>
              <img src="/images/earn-beyond/icon-add.svg" alt="Referral icon" className={styles.icon}/>
            </div>
            <h3 className={styles.cardTitle}>
              Invite. Earn.<br />Repeat. Grow now.
            </h3>
            <a href={signUpUrl} className={styles.viewButton}>
              <span className={styles.buttonText}>View More</span>
              <div className={styles.arrowIconWrapper}>
                <div className={styles.arrowIcon}>
                  <img src="/images/earn-beyond/arrow-small.svg" alt="" role="presentation"/>
                </div>
              </div>
            </a>
          </div>

          <div className={styles.card}>
            <div className={styles.iconWrapper}>
              <img src="/images/earn-beyond/icon-flash.svg" alt="Commission icon" className={styles.icon}/>
            </div>
            <h3 className={styles.cardTitle}>
              Referral Commissions<br />paid in USDT
            </h3>
            <a href={signUpUrl} className={styles.viewButton}>
              <span className={styles.buttonText}>View More</span>
              <div className={styles.arrowIconWrapper}>
                <div className={styles.arrowIcon}>
                  <img src="/images/earn-beyond/arrow-small.svg" alt="" role="presentation"/>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className={styles.bannerSection}>
          <div className={'banner_section_video'}>
            <video autoPlay loop muted playsInline className={'video'}>
              <source src="/videos/unicorn-1764855683645.mp4" type="video/mp4"/>
            </video>
          </div>
          <div className={styles.bannerContent}>
            <h2 className={styles.bannerTitle}>Expand your earning potential</h2>
            <p className={styles.bannerSubtitle}>
              Generate additional value by investing, referring new participants, and accessing exclusive early opportunities.
            </p>
          </div>
        </div>
      </div>
    </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3d6__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//EarnBeyondSection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3d6__ as getStaticProps }
  